export class MessageFactory {
  constructor() {}

  getMessage(code) {
    let messages = {
      REQUIRED_FIELD: 'This field is required!',
      PASSWORD_MATCH_ERROR: 'Password and Confirmation should match',
      WRONG_CREDENTIALS: 'Please check Username and Password',
      WRONG_PHONE_NUMBER: 'Please check your Phone Number',
      LOGGED_SUCCESS: 'Logged Sucessfully!',
      MOBILE_NUMBER_INVALID: 'Please Enter Valid Mobile Number',
      EMAIL_INVALID: 'Please enter valid Email address',
      PASSWORD_MAXLENGTH: 'Password should have less than 255 characters',
      PASSWORD_MINLENGTH: 'Password must be at least 3 characters',
      TEAMNAME_MINLENGTH: 'TeamName must be at least 6 characters',
      NICKNAME_MINLENGTH: 'NickName must be at least 6 characters',
      SELECT_ATLEAST_ONE_TASK: 'Please select at least one children',
      CITY_MAXLENGTH: 'City should have less than 50 characters',
      BILLINGADDRESS_MAXLENGTH:
        'Billing Address should have less than 50 characters',
      CARDNUMBER_MAXLENGTH: 'Card number should have less than 17 characters',
      CARDCODE_MAXLENGTH: 'Card code should have less than 4 characteres',
      PHONENUMBER_EXIST_400: 'Phone number already registered',
      SERVER_ERROR:
        'Looks like something went wrong, please try again later...',
      DEACTIVATED_ACCOUNT: 'Your account was deactivated.',
      TAKE_PICTURE: 'Take a pic to show as proof.',
      INVALID_IMAGE: 'Please upload a valid image file',
      INVITE_ERROR: 'Please verify your invite',
      FIRST_LAST_NAME_ERROR: 'Please enter first and last name',
      BACKEND_ERROR: 'Something went wrong with our end :(',
      GET_IMAGE_ERROR: 'The image could not be loaded',
      ASK_NOT_FOUND: 'Ask not found',
      ASK_ALREADY_FULFILLED: 'Ask not found or already fulfilled',
      INTERESTS_EMPTY: 'You have to add at least one interest'
    };
    return messages[code];
  }
}



// WEBPACK FOOTER //
// ./src/app/factories/message.factory.ts